export default "__VITE_ASSET__JQSH2EwN__"